import React, {useCallback, useEffect, useMemo, useRef, useState,} from "react";
import {BackIcon} from "../../../../assets/icons/profileIcons";
import {useNavigate, useParams} from "react-router-dom";
import {Button, Col, notification, Row,} from "antd";
import {AnniversaryIcon, CakeIcon, CalendarIcon, CalnedarTickIcon,} from "../../../../assets/icons/sidebarIcons";
import {Form} from "react-bootstrap";
import {Controller, useForm} from "react-hook-form";
import {Required,} from "../../../utils/patterns";
import ThemeButton from "../../../components/common/theme-button/ThemeButton";
import {DropDownCheck, PenIconSession, RoundedCheck,} from "../../../../assets/icons/defaultIcons";
import {
    CoachingClientById,
    CreateCoachSessions,
    GetCoachSessions,
    GetSingleCoachSessions,
} from "../../../services/coaching.service";
import {formateDate} from "../../../utils/constant";
import ThemeModals from "../../../components/common/modals/theme-modals/ThemeModals";
import dayjs from "dayjs";
import ThemeDatePicker from "../../../components/common/date-picker/ThemeDatePicker";
import debounce from "lodash.debounce";
import ClientNoteDetailsSkeleton from "../../skeletons/coaching/ClientNoteDetailsSkeleton";
import DemoImage from "../../../../assets/images/d-image.png";

const NoteDetails = () => {
    let { id } = useParams();
    let navigate = useNavigate();
    const seesionRef = useRef("");
    const [sessionEdit, setSessionEdit] = useState(null);
    const [filterSelected, setSelectedFilter] = useState("All");
    const [isLoading, setIsLoading] = useState(true);
    const [isLoadingSession, setIsLoadingSession] = useState(true);
    const [isReadMore, setIsReadMore] = useState(false);
    const [clientSession, setClientSession] = useState([]);
    const [clientData, setClientData] = useState(null);
    const [clientSingleData, setClientSingleData] = useState(null);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [alertModalIsOpen, setAlertModalIsOpen] = useState(false);
    const [renderContent, setRenderContent] = useState(false);
    const [searchVal, setSearchVal] = useState(null);

    let todayData = new Date();

    const toggleReadMore = () => {
        setIsReadMore(!isReadMore);
    };

    const {
        handleSubmit,
        reset,
        setValue,
        formState: { errors },
        control,
        clearErrors,
        watch,
    } = useForm({
        mode: "onChange",
    });

    const onSubmit = async (data) => {
        let clientId = "";
        if (sessionEdit !== null) {
            clientId = sessionEdit?._id;
        }
        let payload = {
            clientId: id,
            coachingStart: data?.start_date,
            coachingEnd: data?.end_date,
            // anniversary: data?.aniversary_date,
            sessionNote: data?.session_note,
            coachNote: data?.coach_note,
            // actionItems: data?.action_items,
        };
        try {
            let res = await CreateCoachSessions(payload, clientId);
            if (res?.data?.data?.status) {
                notification.success({
                    message: "Success",
                    description: res?.data?.data?.message,
                    placement: "topRight",
                    icon: <RoundedCheck />,
                    duration: 2,
                });
            }
        } catch (error) {
            console.log("ThisIsErr", error);
            console.log("ThisIsErr2", error?.response);
        } finally {
            setSessionEdit(null);
            setRenderContent(!renderContent);
            reset({
                session_note: "",
                coach_note: "",
                action_items: "",
            });
        }
    };

    const HandleSelectFilter = (val) => {
        setSelectedFilter(val);
    };

    const items = [
        {
            key: "1",
            label: (
                <a
                    onClick={() => HandleSelectFilter("All")}
                    className={"d-flex justify-content-between w-100"}
                >
                    All{" "}
                    {filterSelected === "All" && (
                        <span>
              <DropDownCheck />
            </span>
                    )}
                </a>
            ),
        },
        {
            key: "2",
            label: (
                <a
                    onClick={() => HandleSelectFilter("Newest")}
                    className={"d-flex justify-content-between w-100"}
                >
                    Newest{" "}
                    {filterSelected === "Newest" && (
                        <span>
              <DropDownCheck />
            </span>
                    )}
                </a>
            ),
        },
        {
            key: "3",
            label: (
                <a
                    onClick={() => HandleSelectFilter("Oldest")}
                    className={"d-flex justify-content-between w-100"}
                >
                    Oldest{" "}
                    {filterSelected === "Oldest" && (
                        <span>
              <DropDownCheck />
            </span>
                    )}
                </a>
            ),
        },
    ];

    const handleKeyDown = (event) => {
        if (event.key === "Enter") {
            event.preventDefault();
            setSearchVal(event.target.value);
        }
    };

    useEffect(() => {
        if (sessionEdit !== null) {
            setValue("session_note", sessionEdit?.sessionNote);
            setValue("coach_note", sessionEdit?.coachNote);
            setValue("action_items", sessionEdit?.actionItems);
            setValue("start_date", sessionEdit?.coachingStart);
            setValue("end_date", sessionEdit?.coachingEnd);
            setValue("aniversary_date", sessionEdit?.anniversary);
        }
    }, [sessionEdit]);

    const HandleGetClientById = async () => {
        let res = await CoachingClientById(id);
        setClientData(res?.data?.data?.data);
        setIsLoading(false);
    };

    const HandleSession = async (searchTerm) => {
        let orderBy =
            filterSelected == "Newest"
                ? "desc"
                : filterSelected == "Oldest"
                ? "asc"
                : "desc";
        let sessionParams = {
            clientId: id,
            search: searchTerm,
            pagination: false,
            sort: "createdAt",
            order: orderBy,
        };
        let response = await GetCoachSessions(sessionParams);
        setClientSession(response?.data?.data?.data?.sessions);
        setIsLoadingSession(false);
    };


    const GetSingleSession = async (searchTerm) => {
        let response = await GetSingleCoachSessions(id);
        setClientSingleData(response?.data?.data?.data);
        setIsLoadingSession(false);
    };

    useEffect(()=>{
        GetSingleSession()
    },[])

    const debouncedHandleSearch = useMemo(
        () =>
            debounce(async (newSearchTerm) => {
                if (newSearchTerm) {
                    HandleSession(newSearchTerm);
                } else {
                    HandleSession();
                }
            }, 500),
        []
    );

    const debounceRequest = useCallback(
        (newSearchTerm) => debouncedHandleSearch(newSearchTerm),
        [debouncedHandleSearch]
    );

    useEffect(() => {
        setIsLoading(true);
        setIsLoadingSession(true);
        HandleGetClientById();
    }, [renderContent]);

    useEffect(() => {
        HandleSession();
    }, [filterSelected, renderContent]);

    const HandleBack = () => {
        if (sessionEdit !== null) {
            setAlertModalIsOpen(true);
        } else {
            navigate(-1);
        }
    };

    if (isLoading || isLoadingSession) {
        return <ClientNoteDetailsSkeleton/>;
    }

    return (
        <>
            <Form onSubmit={handleSubmit(onSubmit)}>
                <div className="main_div_client_details">
                    <div className="inner_div">
                        <div className="header">
                          <span onClick={HandleBack}>
                            <BackIcon />
                          </span>
                            <h3><span>{clientSingleData?.client[0].fullName}</span> <span className={'icon'} onClick={()=>{navigate(`/coaching/edit-note/${id}`)}}>  <PenIconSession /></span></h3>
                        </div>

                        <Row gutter={[16, 16]} style={{ marginTop: "20px" }}>
                            <Col lg={24} xl={24} md={24}>
                                <div className="col_1_div">
                                    <div className="inner_div_col_1">
                                        <div className="client_info">
                                            <div className="inner_client_info">
                                                <p>Client Info</p>
                                                {/*                        <span onClick={() => setModalIsOpen(true)}>*/}
                                                {/*  <PenIconSession />*/}
                                                {/*</span>*/}
                                            </div>
                                            <div className="profile">
                                                <div className="img_div">
                                                    <img src={clientSingleData?.client[0]?.profileImage || DemoImage} />
                                                </div>
                                                <div>
                                                    <p>{clientSingleData?.client[0]?.fullName}</p>
                                                    <p className="para">{clientSingleData?.client[0]?.email}</p>
                                                </div>
                                            </div>
                                            <div className="events_section">
                                                <div className="inner_events">
                                                    <CalendarIcon />
                                                    <p>Coaching Start</p>
                                                </div>
                                                <p>
                                                    {clientSingleData?.coachingStart !== null &&
                                                    clientSingleData?.coachingStart
                                                        ? formateDate(
                                                            clientSingleData?.coachingStart
                                                        )
                                                        : "-"}
                                                </p>
                                            </div>
                                            <div className="events_section">
                                                <div className="inner_events">
                                                    <CalnedarTickIcon />
                                                    <p>Coaching End</p>
                                                </div>
                                                <p>
                                                    {" "}
                                                    {clientSingleData?.coachingEnd !== null &&
                                                    clientSingleData?.coachingEnd
                                                        ? formateDate(  clientSingleData?.coachingEnd)
                                                        : "-"}
                                                </p>
                                            </div>
                                            <div className="events_section">
                                                <div className="inner_events">
                                                    <CakeIcon />
                                                    <p>Birthday</p>
                                                </div>
                                                <p>
                                                    {clientSingleData?.client[0].dob !== "" && clientSingleData?.client[0].dob
                                                        ? formateDate(clientSingleData?.client[0].dob)
                                                        : "-"}
                                                </p>
                                            </div>
                                            <div className="events_section">
                                                <div className="inner_events">
                                                    <AnniversaryIcon />
                                                    <p>Anniversary</p>
                                                </div>

                                                <p>
                                                    {clientSingleData?.anniversary !== null &&
                                                    clientSingleData?.anniversary
                                                        ? formateDate(  clientSingleData?.anniversary)
                                                        : "-"}
                                                </p>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </Col>
                            <Col lg={12} xl={12} md={24}>
                                <div className={'col_1_div'}>
                                    <div className={'inner_div_col_1'}>
                                        <div className="session_main_div">
                                            <h5 className={'pt-0'}>Session Note</h5>
                                            <h6>{clientSingleData?.sessionNote ? clientSingleData?.sessionNote : '-'}</h6>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                            <Col lg={12} xl={12} md={24}>
                                <div className="col_1_div mb-4">
                                    <div className="inner_div_col_1">
                                        <div className="form_div">
                                            <h5>Coach Note</h5>
                                            <h6>{clientSingleData?.coachNote ? clientSingleData?.coachNote : '-'}</h6>
                                        </div>
                                    </div>
                                </div>
                                <div className="col_1_div">
                                    <div className="inner_div_col_1">
                                        <div className="form_div">
                                            <h5>Action Items</h5>
                                            <h6>{clientSingleData?.actionItems ? clientSingleData?.actionItems : '-' }</h6>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </div>
                <ThemeModals
                    open={modalIsOpen}
                    close={setModalIsOpen}
                    title={sessionEdit !== null ? "Edit Info" : "Add Info"}
                    className={"forum_modal"}
                    content={
                        <div style={{ marginTop: "10px" }}>
                            <div className={"dfields"}>
                                <Controller
                                    name="start_date"
                                    // defaultValue={"Evan"}
                                    control={control}
                                    rules={{
                                        required: Required,
                                    }}
                                    render={({ field: { name, ...field } }) => (
                                        <ThemeDatePicker
                                            label={"Coaching Start Date"}
                                            field={field}
                                            fieldName={name}
                                            errors={errors.start_date}
                                            setValue={setValue}
                                            defaultValue={dayjs(
                                                clientData?.lastSession !== null &&
                                                sessionEdit !== null &&
                                                clientData?.lastSession?.coachingStart
                                                    ? formateDate(clientData?.lastSession?.coachingStart)
                                                    : formateDate(todayData),
                                                "MM/DD/YYYY"
                                            )}
                                        />
                                    )}
                                />
                            </div>
                            <div className={"dfields"}>
                                <Controller
                                    name="end_date"
                                    // defaultValue={"Evan"}
                                    control={control}
                                    rules={{
                                        required: Required,
                                    }}
                                    render={({ field: { name, ...field } }) => (
                                        <ThemeDatePicker
                                            label={"Coaching End Date"}
                                            field={field}
                                            fieldName={name}
                                            errors={errors.end_date}
                                            setValue={setValue}
                                            defaultValue={dayjs(
                                                clientData?.lastSession !== null &&
                                                sessionEdit !== null &&
                                                clientData?.lastSession?.coachingEnd
                                                    ? formateDate(clientData?.lastSession?.coachingEnd)
                                                    : formateDate(todayData),
                                                "MM/DD/YYYY"
                                            )}
                                        />
                                    )}
                                />
                            </div>
                            <div className={"dfields"}>
                                <Controller
                                    name="aniversary_date"
                                    // defaultValue={"Evan"}
                                    control={control}
                                    render={({ field: { name, ...field } }) => (
                                        <ThemeDatePicker
                                            label={"Anniversary Date"}
                                            field={field}
                                            fieldName={name}
                                            errors={errors.aniversary_date}
                                            defaultValue={dayjs(
                                                clientData?.lastSession !== null &&
                                                sessionEdit !== null &&
                                                clientData?.lastSession?.anniversary
                                                    ? formateDate(clientData?.lastSession?.anniversary)
                                                    : formateDate(todayData),
                                                "MM/DD/YYYY"
                                            )}
                                            setValue={setValue}
                                        />
                                    )}
                                />
                            </div>
                            <div>
                                <ThemeButton
                                    text={"Done"}
                                    className={"btn-light-lg"}
                                    onClick={() => setModalIsOpen(false)}
                                />
                            </div>
                        </div>
                    }
                />
                <ThemeModals
                    open={alertModalIsOpen}
                    close={setAlertModalIsOpen}
                    title={"Alert"}
                    className={"forum_modal"}
                    content={
                        <div>
                            <p style={{ color: "white", fontSize: "15px" }}>
                                You have not saved you changes, are you sure you want to leave
                                this page.
                            </p>
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "center",
                                    justifyContent: "end",
                                    gap: "15px",
                                }}
                            >
                                <Button
                                    type="text"
                                    style={{ color: "white" }}
                                    onClick={() => setAlertModalIsOpen(false)}
                                >
                                    No
                                </Button>
                                <Button
                                    type="text"
                                    style={{
                                        color: "black",
                                        backgroundColor: "#D2A84E",
                                        width: "90px",
                                    }}
                                    onClick={() => {
                                        setAlertModalIsOpen(false);
                                        setSessionEdit(null);
                                        setRenderContent(!renderContent);
                                        reset({
                                            session_note: "",
                                            coach_note: "",
                                            action_items: "",
                                        });
                                    }}
                                >
                                    Yes
                                </Button>
                            </div>
                        </div>
                    }
                />
            </Form>
        </>
    );
};

export default NoteDetails;
